import { countriesQuery, useAxiosInstance, usePoQuery } from '@gov-nx/api';
import { has } from '@gov-nx/core/types';
import { AlphabeticalComparator } from '@gov-nx/utils/common';
import { useAppLanguage } from '../Localization/useAppLanguage';

export const useCountriesQuery = () => {
	const { language } = useAppLanguage();
	const { axiosInstance } = useAxiosInstance();

	const query = usePoQuery({
		queryKey: ['profile-rob-countries'],
		queryFn: () => countriesQuery(axiosInstance),
	});

	const countryOptions =
		query.data?.seznam
			?.filter(has('kod'))
			.map((country) => ({
				value: country.kod,
				label: language === 'cs' ? country.nazevCs : country.nazevEn,
			}))
			.sort(AlphabeticalComparator) ?? [];

	return { countryOptions, isLoading: query.isLoading };
};
